const data = [
    {
        "id": 1,
        "companyName": "ShoreSite Web Designs",
        "jobTitle": "Full Stack Developer",
        "duration": "December 2021 - Present",
        "description": "Implementing new features for more performant mobile applications and sites. Debugging and testing client sites provides a smoother UI that maximizes revenue."
    },
    {
        "id": 2,
        "companyName": "2U",
        "jobTitle": "Full Stack Development Tutor",
        "duration": "June 2021 - Present",
        "description": "Providing bootcamp students instructional guidance in JavaScript, jQuery, React, Node.js, HTML, CSS, REST API, Handlebars, MySQL, and MongoDB. Tutoring production level software by providing structured code reviews and promoting understanding. Training students to become self-sufficient developers by detecting and resolving faulty code."
    },
    {
        "id": 3,
        "companyName": "Williams Honor",
        "jobTitle": "Touring Bassist",
        "duration": "2020 - Present",
        "description": "Touring bassist for country rock duo. Backed artist all over the tri-state area since October 2020."
    },
    {
        "id": 4,
        "companyName": "Mike Orlando & Corey Glover",
        "jobTitle": "Touring & Recording Bassist",
        "duration": "2019 - Present",
        "description": "Touring/recording bassist for rock, funk, metal artist. Backed artist on 5 shows throughout New York City."
    },
    {
        "id": 5,
        "companyName": "Triumph Brewing Company",
        "jobTitle": "Music Consultant & Talent Buyer",
        "duration": "2019 - Present",
        "description": "Booking agent and music consultant for brew pub and music venue. Responsible for booking and scheduling all entertainment for touring and local acts. Handle all necessary production with shows including offers, technical specifications, social media and logistics."
    },
    {
        "id": 6,
        "companyName": "Dana Fuchs",
        "jobTitle": "Touring & Recording Bassist",
        "duration": "2017 - Present",
        "description": "Touring bass for rock, soul, RnB artist. Backed Dana for 17 tours all over the United States and Europe."
    },
    {
        "id": 7,
        "companyName": "Gedeon Luke & the People",
        "jobTitle": "Touring & Recoring Bassist",
        "duration": "2015 - 2020",
        "description": "Touring bass for funk, soul, gospel artist. Backed Gedeon for the past 5 years on over 20 tours and TV screenings."
    },
    {
        "id": 8,
        "companyName": "Aguilar Bass Amplification",
        "jobTitle": "Quality Control",
        "duration": "2015 - 2016",
        "description": "Tested thousands of finished bass amplifiers and bass effects pedals, and managed the packing and shipping."
    },
    {
        "id": 9,
        "companyName": "Big Crown Records",
        "jobTitle": "Sales Internship",
        "duration": "2014 - 2015",
        "description": "Responsible for hundreds of sales, shipping, social media of Funk and Soul record label. Dealt with record distributors globally for the sales of the labels entire catalog as well as handled the shipping logistics and packing. Updated the labels Facebook and Instagram pages with news and events."
    }

]

export default data;